import { defineComponent as _defineComponent } from 'vue'
import { getJsonUrlData } from '@/apis/equipment'
import { nextTick, watch } from 'vue'
import { ref } from 'vue'

import { HistoryType } from '../type'
import MHistoryForm from './m-history-form.vue'

interface PropsType {
  historyList: HistoryType[]
  isDetail: boolean
  isHistoryVisible: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-history-list',
  props: {
    historyList: null,
    isDetail: { type: Boolean },
    isHistoryVisible: { type: Boolean }
  },
  emits: ['onReset', 'onCheckDetail'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  historyList: HistoryType[]
  isDetail: boolean
  isHistoryVisible: boolean
}



const isLoadingDetail = ref(false)
const currentSetting = ref(null)
const detailRef = ref<HTMLElement | null>(null)

const handleClickReSet = (item: any) => {
  emits('onReset', item.setting.save_data)
}

const handleCheckDetail = async (item: any, index: number) => {
  emits('onCheckDetail', item, index)
  const saveData = JSON.parse(item.setting.save_data)
  currentSetting.value =
    typeof saveData === 'string' && saveData.startsWith('http')
      ? (await getJsonUrlData(saveData)).data
      : saveData
  nextTick(() => {
    if (detailRef.value) {
      detailRef.value.scrollTop = 0
    }
  })
}

watch(
  () => props.isHistoryVisible,
  () => {
    nextTick(() => {
      if (detailRef.value) {
        detailRef.value.scrollTop = 0
      }
    })
  }
)

return { __sfc: true,props, emits, isLoadingDetail, currentSetting, detailRef, handleClickReSet, handleCheckDetail, MHistoryForm }
}

})